/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

import 'bootstrap/dist/css/bootstrap.min.css'; // Importa Bootstrap
import './MobileFormControls.css';
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, MemoryRouter } from "react-router-dom";
import App from "./App";
import { PmsThemeProvider } from "./Components/PmsThemeContext";
import { CurrencyDisplayProvider } from "./currency/CurrencyDisplayContext";
import { installDemoFetchGuard } from "./demo/demoApi";

installDemoFetchGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
const app = (
  <PmsThemeProvider>
    <CurrencyDisplayProvider>
      <App />
    </CurrencyDisplayProvider>
  </PmsThemeProvider>
);
const isStaticDemoBuild = process.env.REACT_APP_PILCORE_DEMO_BUILD === "true";

root.render(
  isStaticDemoBuild ? (
    <MemoryRouter initialEntries={["/demo"]}>
      {app}
    </MemoryRouter>
  ) : (
    <BrowserRouter>
      {app}
    </BrowserRouter>
  )
);
